import React, { useState, useEffect } from "react"
import { useIntl } from "react-intl"
import formatCurrency from "../../helpers/currencyHelper"
import { AlertError, AlertLoading } from '../../helpers/AlertHelper'

import PayrollsService from "../../services/PayrollsService"

import BarChart from "../../components/charts/BarChart"

const PayrollsReports = ({ onChangeDataset, yearFrom = null, yearTo = null }) => {
    const intl = useIntl()
    
    const [payrollsDataset, setPayrollsDataset] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false)
    const [error, setError] = useState(null)

    // Fetch payrolls dataset
    const fetchPayrollsDataset = async () => {
        try {
            const response = await PayrollsService.getPayrollsDataset({ yearFrom, yearTo })
            const { labels, datasets } = response.data.dataset

            // Construcción del dataset directamente al obtener los datos
            const formattedDataset = {
                labels,
                datasets: [
                    {
                        label: intl.formatMessage({ id: "payrollsTotalAmount", defaultMessage: "Total amount" }),
                        data: datasets[0].data,
                        yAxisID: "y",
                        borderColor: "rgb(53, 162, 235)",
                        backgroundColor: "rgba(53, 162, 235, 0.5)",
                        maxBarThickness: 50,
                        datalabels: {
                            anchor: 'end',
                            align: 'end',
                            color: '#333',
                            rotation: -45,
                            font: {
                                weight: 'bold',
                                size: 12
                            },
                            formatter: value => formatCurrency(value),
                        },
                    },
                ],
            }

            setPayrollsDataset(formattedDataset)
            onChangeDataset({
                ...formattedDataset,
                datasets: [formattedDataset.datasets[0]],
                totalAmountsSum: response.data.dataset.totalAmountsSum,
                totalPayrollsSum: response.data.dataset.totalPayrollsSum
            })
            setIsLoaded(true)
        } catch (err) {
            setIsLoaded(false)
            setError(err)
        }
    }

    // Re-fetch data on page/perPage change
    useEffect(() => {
        fetchPayrollsDataset()
    }, [yearFrom, yearTo])

    return (
        <>
            {error && <AlertError error={error} />}
            {!isLoaded && <AlertLoading isLoaded={isLoaded} />}
            {isLoaded && (
                <BarChart
                    //title={intl.formatMessage({ id: "navPayrolls", defaultMessage: "Customers Payrolls" })}
                    data={payrollsDataset}
                />
            )}
        </>
    )
}

export default PayrollsReports